type GetSlideIndexProps = {
  newIndex: number;
  length: number;
  loop: boolean;
};

export const getSlideIndex = ({
  newIndex,
  length,
  loop,
}: GetSlideIndexProps): number => {
  const last = length - 1;
  if (newIndex < 0) {
    return loop ? (newIndex % length) + length : 0;
  }
  if (newIndex > last) {
    return loop ? (newIndex - length) % length : last;
  }
  return newIndex;
};
